<template>
  <footer class="app-footer">
    <p>© 2025 MovieFlix. All rights reserved.</p>
  </footer>
</template>

<style scoped>
.app-footer {
  background-color: #111;
  color: #aaa;
  text-align: center;
  padding: 1.5rem 0;
  font-size: 1.3rem;
  border-top: 1px solid #222;
}
</style>
